import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64c237aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "MP4格式，文件最大不可以超过500MB.", -1))

import {
  ref,
  reactive,
  computed,
  watch,
  RefImpl,
  getCurrentInstance,
  onMounted,
} from 'vue'
import { useStore } from 'vuex'
import { ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { Plus } from '@element-plus/icons-vue'
import type {
  ComponentSize,
  FormInstance,
  FormRules,
  RuleForm,
} from 'element-plus'

import qs from 'qs'
import { Api } from '@/services/http'
import HelpCollapse from './HelpCollapse.vue'
import { chinaProvinceArea } from '@/libs/defined'


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishRoast',
  props: {
  onConfirm: {
    type: Function,
  },
  onMounted: {
    type: Function,
  },
},
  setup(__props, { expose: __expose }) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const activeName = ref('1')
const form = ref(null)
const imageList = ref<any[]>([])
const videoList = ref<any>([])
const instance = getCurrentInstance()

const props = __props

const cascaderProps = {
  checkStrictly: true, // 允许选择任意一级
}

const pageData = reactive({
  cityOptions: chinaProvinceArea,
  industryOptions: [],
  businessItems: [],
  ruleForm: {
    title: '',
    
    image: '',
    video: '',

    content: '',
    comeFrom: '',
  },
})
//** 行业数据载入 */
const industry = computed(() => {
  return store.state.base.businessItems
})
const optionsIndustry = computed(() => {
  let items = []
  if (pageData.businessItems.length) {
    items = pageData.businessItems
  }
  if (store.state.base.businessItems.length) {
    items = store.state.base.businessItems
  }

  const find = items.find(item => item.type == 'industry')
  if (find) {
    return find.items
  } else {
    return []
  }
})
watch(industry, newData => {
  pageData.businessItems = [...newData]
})
//** 行业数据载入 */

const uploadHeader = reactive({
  token: localStorage.getItem('token'),
})
const handleCoverImage = (response, uploadFile) => {
  console.log('response,,', response, uploadFile)
  const { data } = response
  if (data && data.url) {
    pageData.ruleForm.coverImage = data.url
  }
}
const handleChange = () => {}
const handleBeforeCoverImage = () => {}

const handleImage = (response, uploadFile) => {
  if( response.code == 402 ){
    ElMessageBox({
      type:'error',
      message:response.message||'未知错误'
    })
  }
}
const handleImageRemove = (uploadFile, uploadFiles) => {}
const handleVideo = (response, uploadFile) => {
  videoList.value = [uploadFile]
}
const rules = reactive<FormRules<RuleForm>>({
  title: [
    { required: true, message: '标题必填', trigger: 'blur' },
    {
      validator(rule, value, callback, source, options) {
        const errors = []
        if (value.length <= 5) {
          errors.push('标题长度必须超过5个字符')
        }
        return errors
      },
    },
  ],
  region: [
    { required: true, message: '必填' },
    {
      validator(rule, value, callback, source, options) {
        const errors = []
        if (value.length <1) {
          errors.push('必填')
        }
        return errors
      },
    },
  ],
  contact: [{ required: true, message: '联系人必填', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '必填', trigger: 'blur' }],
  coverImage: [{ required: true, message: '封面必填' }],
  content: [{ required: true, message: '文章内容不能为空' }],
})
// 对话框方法名，不要修改它的名称
const dialogSubmit = async () => {
  return await submitForm(form.value)
}
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return false;
  await formEl.validate(async (valid, fields) => {
    const payload = {
      ...pageData.ruleForm,
    }
    payload.comeFrom = pageData.ruleForm.region[2] ?? ''
   

    payload.image = (imageList.value||[])
      .map(item => {
        if( item.response.data ){
          return item.response.data.url
        }
        return ''
        
      })

    payload.image = (payload.image||[]).filter(item=> !!item);
    payload.image = payload.image.join(',')
    payload.video = videoList.value
      .map(item => {
        return item.response.data.url
      })
      .join(',')

    if (valid) {
      const res = await Api.post(
        `/client-api/roast/save`,
        qs.stringify(payload)
      )
      if ((res.code + '').length >= 4) {
        const msg = res.message
        if ((msg + '').indexOf('星级') != -1) {
          ElMessageBox.confirm('请先完成一星级认证', '警告', {
            confirmButtonText: '前往开启',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              router.push('/ucenter/vip')
            })
            .catch(() => {
              
            })
        } else {
          ElMessageBox({
            type: 'error',
            message: msg || '操作失败',
          }).then(()=>{
            ElMessageBox.close()
          })
        }
      } else {
        ElMessageBox.confirm('发布生成', '通知', {
          confirmButtonText: '',
          cancelButtonText: '取消',
          type: 'success',
        })
          .then(() => {
            router.push('/ucenter/publish')
          })
          .catch(() => {
            router.go(-1)
          })
      }
      return true
    } else {
      console.log('error submit!', fields)
      return false
    }
  })
  return false
}

onMounted(() => {
  props.onMounted && props.onMounted(instance)
})
__expose({
  dialogSubmit,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "form",
      ref: form,
      model: pageData.ruleForm,
      rules: rules,
      "label-width": "auto",
      class: "demo-ruleForm",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "标题",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: pageData.ruleForm.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageData.ruleForm.title) = $event)),
              style: {"max-width":"400px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "内容",
          prop: "content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: pageData.ruleForm.content,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pageData.ruleForm.content) = $event)),
              style: {"width":"500px"},
              size: "large",
              rows: "10"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "图片",
          prop: "image"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "hidden",
              modelValue: pageData.ruleForm.image,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pageData.ruleForm.image) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_upload, {
              "file-list": imageList.value,
              "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((imageList).value = $event)),
              class: "poster-uploader-images",
              action: "https://wx.dpxtd.com/system/file/upload",
              accept: "image/png,image/jpeg,image/jpg,image/gif",
              multiple: "",
              headers: uploadHeader,
              "list-type": "picture-card",
              "on-success": handleImage,
              "on-preview": _ctx.handleImagePreview,
              "on-remove": handleImageRemove
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["file-list", "headers", "on-preview"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "视频" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              "file-list": videoList.value,
              "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((videoList).value = $event)),
              class: "upload-demo",
              action: "https://wx.dpxtd.com/client-api/util/upload",
              headers: uploadHeader,
              accept: "video/mp4",
              "list-type": "card",
              "on-success": handleVideo,
              "before-remove": _ctx.beforeRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed
            }, {
              tip: _withCtx(() => [
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode("点击上传")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["file-list", "headers", "before-remove", "on-exceed"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "地区",
          prop: "region"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              placeholder: "请选择",
              modelValue: pageData.ruleForm.region,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pageData.ruleForm.region) = $event)),
              options: pageData.cityOptions,
              props: cascaderProps,
              onChange: handleChange
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})